/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_settings_subtitle = /** @type {(inputs: { username: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Manage your password and passkeys for ${i?.username}`)
};

const zh_hans1_settings_subtitle = /** @type {(inputs: { username: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`管理 ${i?.username} 的密码和通行密钥`)
};

const zh_hant1_settings_subtitle = /** @type {(inputs: { username: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`管理 ${i?.username} 的密碼與通行金鑰`)
};

const fr_settings_subtitle = /** @type {(inputs: { username: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gérez votre mot de passe et vos passkeys pour ${i?.username}`)
};

const de_settings_subtitle = /** @type {(inputs: { username: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Verwalte Passwort und Passkeys für ${i?.username}`)
};

const ja_settings_subtitle = /** @type {(inputs: { username: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.username} のパスワードとパスキーを管理`)
};

const ko_settings_subtitle = /** @type {(inputs: { username: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.username}의 비밀번호와 패스키를 관리하세요`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ username: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const settings_subtitle = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.settings_subtitle(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("settings_subtitle", locale)
	if (locale === "en") return en_settings_subtitle(inputs)
	if (locale === "zh-Hans") return zh_hans1_settings_subtitle(inputs)
	if (locale === "zh-Hant") return zh_hant1_settings_subtitle(inputs)
	if (locale === "fr") return fr_settings_subtitle(inputs)
	if (locale === "de") return de_settings_subtitle(inputs)
	if (locale === "ja") return ja_settings_subtitle(inputs)
	return ko_settings_subtitle(inputs)
};